import * as React from "react";
import { Field, useField } from "formik";
import { useQuery } from "@tanstack/react-query";
import * as API from "@graylog/server-api";
import { Input } from "components/bootstrap";
import { FormikInput, MultiSelect } from "components/common";
import Spinner from "components/common/Spinner";
import FormikSwitch from "report/report-creation/FormikSwitch";
import PlusButton from "report/report-creation/common/PlusButton";
import ReportScheduling from "report/report-creation/overview/ReportScheduling";
import Separator from "report/report-creation/Separator";
const handleMultiSelectChange = (value) => value === "" ? [] : value.split(",");
const toSelectValue = (values) => Array.isArray(values) ? values.join(",") : "";
const fetchUsers = async () => {
  const users = await API.Users.listUsers(false, false);
  return users.users.map((user) => ({ label: `${user.full_name}`, value: user.username }));
};
const useUserOptions = () => useQuery({
  queryKey: ["users"],
  queryFn: fetchUsers
});
const Delivery = ({ editAllowed }) => {
  const { data: usersOptions, isLoading } = useUserOptions();
  const [{ value: deliveryActive }] = useField("delivery.active");
  return isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReportScheduling, { disabled: !deliveryActive, editAllowed }, ({ createScheduling }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormikSwitch, { label: "Schedule", name: "delivery.active", disabled: !editAllowed }), /* @__PURE__ */ React.createElement(PlusButton, { title: "Add schedule", onClick: createScheduling, disabled: !editAllowed }))), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: "email_subject",
      name: "delivery.email_subject",
      label: "Email subject",
      help: "Set an email subject to use when sending the report.",
      required: true,
      disabled: !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: "email_body",
      name: "delivery.email_body",
      type: "textarea",
      label: "Email body",
      help: "Add an email body to use when sending the report.",
      rows: 6,
      required: true,
      disabled: !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(Field, { name: "delivery.user_receivers" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help: "Select usernames that will receive this report.",
      error: error && touched ? error : void 0,
      id: name,
      label: "User recipients",
      disabled: !editAllowed
    },
    /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        onBlur,
        onChange: (selectedReceivers) => onChange({
          target: {
            value: handleMultiSelectChange(selectedReceivers),
            name
          }
        }),
        options: usersOptions,
        inputId: name,
        addLabelText: "Type username",
        placeholder: "Type username",
        value: toSelectValue(value),
        disabled: !editAllowed
      }
    )
  )), /* @__PURE__ */ React.createElement(Field, { name: "delivery.email_receivers" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help: "Add email addresses that will receive this report.",
      error: error && touched ? error : void 0,
      id: name,
      label: "Email recipients",
      disabled: !editAllowed
    },
    /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        onBlur,
        onChange: (selectedReceivers) => onChange({
          target: {
            value: handleMultiSelectChange(selectedReceivers),
            name
          }
        }),
        options: [],
        inputId: name,
        addLabelText: 'Add email "{label}"?',
        placeholder: "Type email address",
        allowCreate: true,
        value: toSelectValue(value),
        disabled: !editAllowed
      }
    )
  )));
};
export default Delivery;
